import script from "./brand-setting.vue?vue&type=script&setup=true&lang=js"
export * from "./brand-setting.vue?vue&type=script&setup=true&lang=js"

import "./brand-setting.vue?vue&type=style&index=0&id=54e5fe18&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e5fe18"]])

export default __exports__